import * as React from 'react';
import { useContext } from 'react';

import { type Domain } from 'bundles/browse-common/types/domain';

export type DomainEntityContextType = {
  domain: Domain;
};

const DomainEntityContext = React.createContext<DomainEntityContextType | undefined>(undefined);

export const useDomainEntity = () => {
  return useContext(DomainEntityContext);
};

export default DomainEntityContext;
